import moment from 'moment'
import store from '@/store'

function timeLimitExceeded(lastSeenTime) {
    if (!lastSeenTime) {
        return true
    }
    const lastSeen = new moment(lastSeenTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
    const now = new moment()
    lastSeen.add(30, 'm')
    return lastSeen.isBefore(now)
}

function getDeviationInRightFormat(lastSeenTime, deviation, block, realtimeStatus) {
    try {
        let showVehicleDeviationDelayAsPlusSign = store.getters?.uiConfiguration?.data?.departure?.showVehicleDeviationDelayAsPlusSign;
        if (showVehicleDeviationDelayAsPlusSign == undefined) {
            showVehicleDeviationDelayAsPlusSign = true;
        }

        if (
            !lastSeenTime ||
            deviation == null ||
            timeLimitExceeded(lastSeenTime)
        )
            return ''

        if( realtimeStatus && !block )
            return ''

        const time = new moment.unix(0)
        const dev = deviation
        time.add(Math.abs(dev) / 1000, 's')
        if ((dev >= 0 && showVehicleDeviationDelayAsPlusSign) || (dev < 0 && !showVehicleDeviationDelayAsPlusSign)) 
            return time.format('+mm:ss')
        else 
            return time.format('-mm:ss')
    } catch (e) {
        return ''
    }
}

function getDeviationInRightFormat2(deviation, isDeviationInSeconds) {
    try {
        let showVehicleDeviationDelayAsPlusSign = store.getters?.uiConfiguration?.data?.departure?.showVehicleDeviationDelayAsPlusSign;
        if (showVehicleDeviationDelayAsPlusSign == undefined) {
            showVehicleDeviationDelayAsPlusSign = true;
        }

        const time = new moment.unix(0);
        const dev = deviation;

        if (isDeviationInSeconds) {
            time.add(Math.abs(dev), 's');
        } else {
            time.add(Math.abs(dev) / 1000, 's');
        }
        
        if ((dev >= 0 && showVehicleDeviationDelayAsPlusSign) || (dev < 0 && !showVehicleDeviationDelayAsPlusSign)) {
            return time.format('+mm:ss');
        }
        else {
            return time.format('-mm:ss');
        }
    } catch (e) {
        return undefined;
    }
}

export default {
    getDeviationInRightFormat,
    getDeviationInRightFormat2
}